export default __webpack_public_path__ + "static/breadcrumbs-overflow-3a12148da105fddb9f02e6dae7640bf2.png";